import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, collection, getDocs } from 'firebase/firestore/lite';
import {getStorage} from 'firebase/storage';
const firebaseConfig = {

  apiKey: "AIzaSyCtduIiBXcoVUMzF5QkIm-HuESlMtdoEWY",

  authDomain: "emytoprod-7ac70.firebaseapp.com",

  projectId: "emytoprod-7ac70",

  storageBucket: "emytoprod-7ac70.appspot.com",

  messagingSenderId: "604168054817",

  appId: "1:604168054817:web:ee6b241a8d6995d4ed5b60",

  measurementId: "G-M5XVTJ9W7Z"

};




// Initialize Firebase

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storages = getStorage(app);